import { IsBoolean, IsOptional } from 'class-validator';
import { BaseDto } from '../base.dto';

export class StockLevelPatchDto extends BaseDto {
  @IsOptional()
  @IsBoolean()
  closed?: boolean;

  @IsOptional()
  @IsBoolean()
  finalized?: boolean;
}